import React from 'react';
import { Plus, Trash2, CheckCircle2, Circle } from 'lucide-react';
import { useLang, tx } from '../../../i18n/LanguageContext';

export const emptyQuestion = () => ({ textAr: '', options: ['', ''], correct: 0 });

export const quizErrors = (qs) => qs.length === 0 || qs.some(q => !q.textAr.trim() || q.options.filter(o => o.trim()).length < 2 || !q.options[q.correct]?.trim());

export const QuizBuilder = ({ questions, onChange }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const upd = (i, patch) => onChange(questions.map((q, k) => (k === i ? { ...q, ...patch } : q)));
  const inp = 'w-full h-9 rounded-lg border border-slate-200 bg-white px-3 text-sm outline-none focus:border-blue-500';
  return (
    <div data-testid="quiz-builder" className="space-y-3">
      {questions.map((q, i) => (
        <div key={i} data-testid={`quiz-q-${i}`} className="rounded-xl border border-slate-200 p-3 space-y-2">
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-blue-600 shrink-0">{L(`سؤال ${i + 1}`, `Q${i + 1}`)}</span>
            <input data-testid={`quiz-q-text-${i}`} value={q.textAr} onChange={e => upd(i, { textAr: e.target.value })} placeholder={L('نص السؤال', 'Question text')} className={inp} />
            {questions.length > 1 && <button type="button" onClick={() => onChange(questions.filter((_, k) => k !== i))} className="p-1.5 text-rose-500 hover:bg-rose-50 rounded-lg"><Trash2 className="w-4 h-4" /></button>}
          </div>
          {q.options.map((o, oi) => (
            <div key={oi} className="flex items-center gap-2 ps-4">
              <button type="button" data-testid={`quiz-q-${i}-correct-${oi}`} onClick={() => upd(i, { correct: oi })} title={L('الإجابة الصحيحة', 'Correct answer')} className="shrink-0">
                {q.correct === oi ? <CheckCircle2 className="w-4 h-4 text-emerald-500" /> : <Circle className="w-4 h-4 text-slate-300" />}
              </button>
              <input data-testid={`quiz-q-${i}-opt-${oi}`} value={o} onChange={e => upd(i, { options: q.options.map((x, k) => (k === oi ? e.target.value : x)) })} placeholder={L(`الخيار ${oi + 1}`, `Option ${oi + 1}`)} className={inp} />
              {q.options.length > 2 && <button type="button" onClick={() => upd(i, { options: q.options.filter((_, k) => k !== oi), correct: q.correct >= oi && q.correct > 0 ? q.correct - 1 : q.correct })} className="p-1 text-slate-400 hover:text-rose-500"><Trash2 className="w-3.5 h-3.5" /></button>}
            </div>
          ))}
          {q.options.length < 4 && <button type="button" onClick={() => upd(i, { options: [...q.options, ''] })} className="ms-4 text-xs text-blue-600 font-semibold hover:underline">{L('+ خيار', '+ Option')}</button>}
        </div>
      ))}
      <button type="button" data-testid="quiz-add-question" onClick={() => onChange([...questions, emptyQuestion()])} className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-blue-300 text-blue-600 text-[13px] font-semibold hover:bg-blue-50">
        <Plus className="w-4 h-4" />{L('إضافة سؤال', 'Add question')}
      </button>
    </div>
  );
};
